export default "__VITE_ASSET__5195ea4a__"